import TreezLogo from './TreezLogo.jsx';

export default TreezLogo;


// WEBPACK FOOTER //
// ./src/components/TreezLogo/index.jsx